import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
} from "../services/types/ComponentTypes";

export const screen_172_batch_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Batch summary",
        style: {
            backgroundColor: "#F9FAFB", // bg-gray-50
        },
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "batch_summary",
                DisplayName: "Batch summary",
                columnNumber: "m1 t1 w1",
                DisableSubmit: true,
                SubmitActions: [
                    {
                        Action: "Navigate",
                        Navigate: "modulev1/purchase_summary",
                    },
                ],
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    padding: 16,
                    borderRadius: 12,
                },
                Fields: [
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Selection",
                        BindValue: "selection_group",
                        columnNumber: "m1 t1 w3",
                        style: {
                            direction: FlexDirection.COLUMN,
                            padding: 16,
                        },
                        childComponents: [
                            {
                                IncludeLabel: true,
                                Label: "Code",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "drp_product",
                                Json_Attribute: "product_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: false,
                                IsVerticalView: true,
                                LookupName: "product_itemcode",
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Order details",
                        BindValue: "batch_details_container",
                        columnNumber: "m1 t1 w1",
                        style: {
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.SUB_MODULE,
                                Label: "",
                                TableName: "",
                                Name: "order_details",
                                BindValue: "batch_details",
                                LookupName: "batch_details_with_product_id",
                                Parent_Field: "drp_product",
                                AllowAdd: false,
                                childControls: [
                                    {
                                        IncludeLabel: true,
                                        Label: "Batch ID",
                                        PlaceHolder: "",
                                        IsMandatory: false,
                                        BindValue: "txt_batchname",
                                        Json_Attribute: "batch_no",
                                        componentType: ComponentType.TEXT_FIELD,
                                        showInSummary: false,
                                        IsVerticalView: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Available qty",
                                        PlaceHolder: "",
                                        IsMandatory: false,
                                        BindValue: "txt_qty",
                                        Json_Attribute: "qty",
                                        componentType: ComponentType.TEXT_FIELD,
                                        showInSummary: false,
                                        IsReadOnly: true,
                                        Default_Value: "0",
                                        inputType: InputType.NUMBER,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Unit rate",
                                        PlaceHolder: "",
                                        IsMandatory: false,
                                        BindValue: "txt_rate",
                                        Json_Attribute: "rate",
                                        componentType: ComponentType.TEXT_FIELD,
                                        showInSummary: false,
                                        IsReadOnly: true,
                                        Default_Value: "0",
                                        inputType: InputType.NUMBER,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
